module.exports = __webpack_public_path__ + "griletto.jpg?48b772971edf7c57e6d4fd9b8c4e3021";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/griletto.jpg
// module id = 119
// module chunks = 0